import { useTranslation } from 'react-i18next';
import { Button, Icon } from '@salecycle/ui-component-library';
import { DisplayWebContentMessageSegmentationRules, TriggerSegmentationRules } from 'sections/onsite-campaigns/types';

interface IProps {
  isAllVisitors?: boolean;
  segmentation: DisplayWebContentMessageSegmentationRules | TriggerSegmentationRules;
  openModal: () => void;
}

export const SelectSegmentationButton = ({ isAllVisitors, segmentation, openModal }: IProps) => {
  const { t } = useTranslation('campaigns');

  if (isAllVisitors) {
    return null;
  }

  const ariaLabel = t('onsite.editor.workflow.triggerMessage.drawer.segmentation.editAudience');

  if (segmentation?.length && segmentation[0].length) {
    return (
      <Button variation="secondary" leftSideIcon={<Icon icon="pen" />} aria-label={ariaLabel} onClick={openModal}>
        {t('onsite.editor.workflow.triggerMessage.drawer.segmentation.editAudience')}
      </Button>
    );
  } else if (segmentation) {
    return (
      <Button variation="primary" leftSideIcon={<Icon icon="plus" />} aria-label={ariaLabel} onClick={openModal}>
        {t('onsite.editor.workflow.triggerMessage.drawer.segmentation.addAudience')}
      </Button>
    );
  } else {
    return (
      <Button variation="secondary" leftSideIcon={<Icon icon="plus" />} aria-label={ariaLabel} onClick={openModal}>
        {t('onsite.editor.workflow.triggerMessage.drawer.segmentation.addAudience')}
      </Button>
    );
  }
};
